import { capitalize } from "lodash";

export interface User {
	stableIdV1: string;
	firstName?: string;
	lastName?: string;
	username: string;
	screenshots?: unknown[];
	/**
	 * Legacy CMS field
	 * @deprecated - use firstName instead
	 */
	fname?: string;
	/**
	 * Legacy CMS field
	 * @deprecated - use lastName instead
	 */
	lname?: string;
	qoriaUserId?: string;
}

export const userDisplayText = (user: User): string => {
	const firstName = user.fname || user.firstName;
	const lastName = user.lname || user.lastName;

	if (firstName || lastName) {
		return `${capitalize(firstName)} ${capitalize(lastName)}`.trim();
	} else {
		return user.username;
	}
};

export const getUserDisplayTextForSelect = (user: User): string => {
	const firstName = user.fname || user.firstName;
	const lastName = user.lname || user.lastName;

	if (firstName && lastName && user.username) {
		return `${capitalize(firstName)} ${capitalize(lastName)}`.trim() + ` - ${user.username}`;
	} else {
		return user.username;
	}
};

export const sortUsersByActivity = (users: User[], lockedUsers: User[], sortByLastName = false): User[] => {
	return users.sort((a, b) => {
		const aBlocked = lockedUsers ? lockedUsers.filter((user) => user.username === a.username).length > 0 : false;
		const bBlocked = lockedUsers ? lockedUsers.filter((user) => user.username === b.username).length > 0 : false;
		const aOnline = !!(a.screenshots && a.screenshots.length > 0);
		const bOnline = !!(b.screenshots && b.screenshots.length > 0);
		const aUsername = a.username;
		const bUsername = b.username;
		if (aOnline && !bOnline) {
			return -1;
		} else if (!aOnline && bOnline) {
			return 1;
		} else if (aBlocked && !bBlocked) {
			return -1;
		} else if (!aBlocked && bBlocked) {
			return 1;
		} else if (a.fname && !b.fname) {
			return -1;
		} else if (!a.fname && b.fname) {
			return 1;
		} else if (a.fname && b.fname && !sortByLastName) {
			const fnameCompared = a.fname.toLowerCase().localeCompare(b.fname.toLowerCase());
			if (fnameCompared === 0 && a.lname && b.lname) {
				const lnameCompared = a.lname.toLowerCase().localeCompare(b.lname.toLowerCase());
				if (lnameCompared === 0) {
					return aUsername.localeCompare(bUsername);
				} else {
					return lnameCompared;
				}
			} else {
				return fnameCompared;
			}
		} else if (a.lname && b.lname && sortByLastName) {
			const lnameCompared = a.lname.toLowerCase().localeCompare(b.lname.toLowerCase());
			if (lnameCompared === 0 && a.fname && b.fname) {
				const fnameCompared = a.fname.toLowerCase().localeCompare(b.fname.toLowerCase());
				if (fnameCompared === 0) {
					return aUsername.localeCompare(bUsername);
				} else {
					return fnameCompared;
				}
			} else {
				return lnameCompared;
			}
		} else {
			if (aUsername !== undefined && bUsername !== undefined) {
				return aUsername.localeCompare(bUsername);
			}
			if (aUsername === undefined && bUsername !== undefined) {
				return -1;
			}
			if (aUsername !== undefined && bUsername === undefined) {
				return 1;
			}
			return 0;
		}
	});
};
